import { SlaConfigSection } from './sla/sla-config-section';
import { SlaDowntimeSection } from './sla/sla-downtime-section';

/**
 * SLA tab — mirrors legacy "Service SLA": the config block (apply a template /
 * manual config, or the configured terms) stacked over the downtime block
 * (period uptime stats + the downtime incident log with record / end / edit /
 * delete). Data lives under `/services/:id/sla*`.
 */
export function ServiceSlaTab({ id }: { id: number }) {
  return (
    <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
      <SlaConfigSection id={id} />
      <SlaDowntimeSection id={id} />
    </div>
  );
}
